import Typography from 'structure/launchpad/components/Typography';
import Button from 'structure/launchpad/components/Button';
import ButtonIcon from 'structure/launchpad/components/ButtonIcon';
import React from 'react';
import { Icons } from '@dapp/multi-lib/ui/icons';
import { Body } from 'components/Typography';
import { twMerge } from 'tailwind-merge';

type ReminderProps = {
  label: React.ReactNode;
  subLabel?: React.ReactNode;
  bgColor?: string;
  button?: React.ReactNode;
  onClose: () => void;
};

export function Reminder({
  label,
  subLabel,
  button,
  bgColor = '#F5F5F5',
  onClose,
}: ReminderProps) {
  return (
    <div
      className={`Content h-13 fixed bottom-0 z-50 w-full justify-end px-4 lg:sticky lg:top-0 lg:h-8 lg:px-0 lg:bg-[${bgColor}]`}
    >
      <div
        className={`mx-auto flex max-w-[100rem] lg:w-full lg:max-w-full bg-[${bgColor}] items-center justify-between py-2 pe-8 ps-2 lg:flex-wrap lg:bg-transparent lg:px-7 lg:py-1.5 xl:px-[90px]`}
        style={{ backgroundColor: bgColor }}
      >
        <Typography className='font-planar flex flex-col text-sm font-medium text-black-1000 lg:flex-row lg:items-center lg:gap-5 lg:text-xl lg:leading-5'>
          {label}
          <Body className='text-xs text-black-400 lg:text-lg lg:leading-5'>
            {subLabel}
          </Body>
        </Typography>
        <div className='shrink-0 ngmd:ml-auto'>{button}</div>
        <div className='absolute right-6 top-0'>
          <ButtonIcon onClick={onClose} className='hover:bg-transparent'>
            <Icons
              icon='close'
              iconWidth={16}
              iconHeight={16}
              fillColor='#111111'
            />
          </ButtonIcon>
        </div>
      </div>
    </div>
  );
}

export function ReminderButton({
  label,
  onClick,
  className,
}: {
  label: string;
  onClick?: () => void;
  className?: string;
}) {
  const classNames = twMerge(
    'rounded-[1.25rem] border bg-transparent px-4 py-2 text-sm font-bold	text-white',
    className
  );
  return (
    <Button onClick={onClick} className={classNames}>
      {label}
    </Button>
  );
}
